// src/components/SearchBar.js
import React, { useState } from 'react';
import { Paper, Grid, Box, IconButton, Chip, Button, FormControl, InputLabel, Select, MenuItem, Typography, InputBase } from '@mui/material';
import { Search as SearchIcon, Close as CloseIcon } from '@mui/icons-material';
import { alpha, styled } from '@mui/material/styles';

const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
    },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '20ch',
        },
    },
}));

export default function SearchBar({ onClose }) {
    const [city, setCity] = useState('');
    const [salary, setSalary] = useState('');
    const [jobType, setJobType] = useState('');

    const handleCityChange = (event) => {
        setCity(event.target.value);
    };

    const handleSalaryChange = (event) => {
        setSalary(event.target.value);
    };

    const handleJobTypeChange = (event) => {
        setJobType(event.target.value);
    };

    return (
        <Paper sx={{ position: 'absolute', top: 64, left: 0, right: 0, zIndex: 10, padding: 2 }}>
            <Grid container spacing={2} justifyContent="space-between">
                <Grid item xs={11}>
                    <Typography variant="h6">搜索推荐</Typography>
                </Grid>
                <Grid item xs={1} sx={{ textAlign: 'right' }}>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Grid>
            </Grid>

            <Grid container spacing={2}>
                {/* 热门标签 */}
                <Grid item xs={12} sm={4}>
                    <Typography variant="h6">热门标签</Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                        <Chip label="#程序员" clickable />
                        <Chip label="#招聘" clickable />
                        <Chip label="#前端开发" clickable />
                        <Chip label="#JavaScript" clickable />
                    </Box>
                </Grid>

                {/* 职位筛选 */}
                <Grid item xs={12} sm={4}>
                    <Typography variant="h6">职位筛选</Typography>
                    <FormControl fullWidth sx={{ marginBottom: 2 }}>
                        <InputLabel id="city-select-label">城市和地区</InputLabel>
                        <Select
                            labelId="city-select-label"
                            value={city}
                            label="城市和地区"
                            onChange={handleCityChange}
                        >
                            <MenuItem value="北京">北京</MenuItem>
                            <MenuItem value="上海">上海</MenuItem>
                            <MenuItem value="深圳">深圳</MenuItem>
                        </Select>
                    </FormControl>

                    <FormControl fullWidth sx={{ marginBottom: 2 }}>
                        <InputLabel id="salary-select-label">薪资</InputLabel>
                        <Select
                            labelId="salary-select-label"
                            value={salary}
                            label="薪资"
                            onChange={handleSalaryChange}
                        >
                            <MenuItem value="10k-20k">10k-20k</MenuItem>
                            <MenuItem value="20k-30k">20k-30k</MenuItem>
                            <MenuItem value="30k以上">30k以上</MenuItem>
                        </Select>
                    </FormControl>

                    <FormControl fullWidth>
                        <InputLabel id="jobtype-select-label">职位性质</InputLabel>
                        <Select
                            labelId="jobtype-select-label"
                            value={jobType}
                            label="职位性质"
                            onChange={handleJobTypeChange}
                        >
                            <MenuItem value="全职">全职</MenuItem>
                            <MenuItem value="兼职">兼职</MenuItem>
                            <MenuItem value="实习">实习</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                {/* 模糊搜索 */}
                <Grid item xs={12} sm={4}>
                    <Typography variant="h6">模糊搜索推荐</Typography>
                    <Button variant="outlined" fullWidth sx={{ marginTop: 1 }}>
                        搜索 "程序员"
                    </Button>
                    <Button variant="outlined" fullWidth sx={{ marginTop: 1 }}>
                        搜索 "前端开发"
                    </Button>
                    <Button variant="outlined" fullWidth sx={{ marginTop: 1 }}>
                        搜索 "JavaScript"
                    </Button>
                </Grid>
            </Grid>
        </Paper>
    );
}